import { IMessage } from '@dtos/Channel'
import { formatDateShort } from '@utils/dateFormatter'
import { Text, YStack } from 'tamagui'
import { AuthorBadge } from '@components/Comments/AuthorBadge'

interface IMessageThreadProps {
  messages: IMessage[]
}

export function MessageThread({ messages }: IMessageThreadProps) {
  return (
    <YStack gap="$spacing-inset-sm" testID="message-thread">
      {messages.map((message) => (
        <YStack
          key={message.id}
          gap="$spacing-inset-xs"
          p="$spacing-inset-md"
          borderRadius="$border-radius-md"
          backgroundColor="$bg-surface"
          testID={`message-${message.id}`}
        >
          <AuthorBadge user={message.sender} size={28} />
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxs"
            color="$text-primary"
          >
            {message.text}
          </Text>
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxxs"
            color="$text-placeholder"
          >
            {formatDateShort(message.createdAt)}
          </Text>
        </YStack>
      ))}
    </YStack>
  )
}
